import { render, staticRenderFns } from "./FundingProjectRequestItem.vue?vue&type=template&id=6d038180&"
import script from "./FundingProjectRequestItem.vue?vue&type=script&lang=js&"
export * from "./FundingProjectRequestItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports